import React, { Fragment, useState } from "react";
import { Row, Col, Card, Form, Modal, Button, Spinner } from "react-bootstrap";
import MyApiClient from "../../../api-client/MyApiClient";

// Pagina Account (struttura e super admin), dal menu del nome in alto a destra
const Impostazioni = () => {

  const account = (() => {
    try { return JSON.parse(sessionStorage.getItem('userDetails')) || {}; } catch { return {}; }
  })();

  const [modalShowed, setModalShowed] = useState(false);
  const [loadingShowed, setLoadingShowed] = useState(false);
  const [modalTitle, setModalTitle] = useState('');
  const [modalText, setModalText] = useState('');
  const defaultHandleClose = () => {
    setModalShowed(false);
  };
  const [handleClose, setHandleClose] = useState(() => defaultHandleClose);

  const [confirmShowed, setConfirmShowed] = useState(false);

  const [formData1, setFormData1] = useState({
    email: ''
  });

  const [formData2, setFormData2] = useState({
    oldpassword: '',
    newpassword: '',
    confirmpassword: ''
  });

  const handleChange1 = (e) => {
    const { name, value } = e.target;
    setFormData1(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleChange2 = (e) => {
    const { name, value } = e.target;
    setFormData2(prevState => ({
        ...prevState,
        [name]: value
    }));
  };

  const handleSaveClick1 = (e) => {
    e.preventDefault();

    if(formData1.email.trim()=='') {
      setModalTitle("Errore durante l'operazione");
      setModalText("Il nuovo indirizzo e-mail deve essere valorizzato per continuare");
      setModalShowed(true);
      return;
    }

    setConfirmShowed(true);
  };

  const handleSaveClick2 = (e) => {
    e.preventDefault();
    
    const saveData2 = async () => {
      try {

        if(formData2.oldpassword.trim()=='' || formData2.newpassword.trim()=='' || formData2.confirmpassword.trim()=='') {
          setModalTitle("Errore durante l'operazione");
          setModalText("Le password devono essere valorizzate per continuare");
          setModalShowed(true);
          return;
        }

        if(formData2.newpassword != formData2.confirmpassword) {
          setModalTitle("Errore durante l'operazione");
          setModalText("La conferma della nuova password non è corretta");
          setModalShowed(true);
          return;
        }

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
          const tokenDetails = JSON.parse(tokenDetailsString);
          const token = tokenDetails.idToken;
          const accessToken = tokenDetails.accessToken;
          const apiClient = new MyApiClient();

          setLoadingShowed(true);
          const [saveResult] = await Promise.all([
            apiClient.changePassword(token, accessToken, formData2.oldpassword, formData2.newpassword)
          ]);
          setLoadingShowed(false);

          if (saveResult && saveResult.error) {
            setModalTitle("Errore durante l'operazione");
            setModalText("Si è verificato un errore durante l'operazione (" + saveResult.error + ")");
            setModalShowed(true);
          } else {
            formData2.oldpassword = '';
            formData2.newpassword = '';
            formData2.confirmpassword = '';

            setModalTitle("Salvataggio completato");
            setModalText("La password è stata aggiornata correttamente, al prossimo accesso dovrai utilizzare la nuova password");
            setModalShowed(true);
          }
        }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    saveData2();
  };

  const continueChangeUsername = () => {

    setConfirmShowed(false);

		const saveData1 = async () => {
      try {

        const tokenDetailsString = sessionStorage.getItem('userDetails');
        if (tokenDetailsString) {
            const tokenDetails = JSON.parse(tokenDetailsString);
            const token = tokenDetails.idToken;
            const apiClient = new MyApiClient();

            setLoadingShowed(true);
            const [saveResult] = await Promise.all([
              apiClient.changeEmail(token, formData1.email)
            ]);
            setLoadingShowed(false);

            if (saveResult && saveResult.error) {
              setModalTitle("Errore durante l'operazione");
              setModalText("Si è verificato un errore durante l'operazione (" + saveResult.error + ")");
              setModalShowed(true);
            } else {
              formData1.email = '';
              
              setModalTitle("Salvataggio completato");
              setModalText("L'indirizzo e-mail è stato aggiornato correttamente");
              setModalShowed(true);
            }
        }
      } catch (error) {
          console.error("Error fetching data:", error);
      }
    };

    saveData1();
	}

  return (
    <>
      <Modal className="fade" show={confirmShowed} centered>
        <Modal.Header>
            <Modal.Title>Sei sicuro? </Modal.Title>
            <Button onClick={() => setConfirmShowed(false)} variant="" className="btn-close">
            </Button>
        </Modal.Header>
        <Modal.Body>
            <Row><Col className="col-xl-64">Il nuovo indirizzo a cui sarà inviato il link per la conferma del cambio è <b>{formData1.email}</b>. Sei sicuro di avere l'accesso a questo indirizzo e-mail?</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
            <Button className="btn btn-light btn-add" onClick={() => setConfirmShowed(false)}>
                Chiudi
            </Button>
            <Button className="btn btn-primary btn-add" onClick={continueChangeUsername}>
                Continua
            </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={modalShowed} centered>
        <Modal.Header>
          <Modal.Title>{modalTitle}</Modal.Title>
          <Button onClick={() => setModalShowed(false)} variant="" className="btn-close">
          </Button>
        </Modal.Header>
        <Modal.Body>
          <Row><Col className="col-xl-64">{modalText}</Col></Row>
        </Modal.Body>
        <Modal.Footer className="justify-content-between">
          <Button className="btn btn-primary btn-add" onClick={handleClose}>
            Chiudi
          </Button>
        </Modal.Footer>
      </Modal>

      <Modal className="fade" show={loadingShowed} centered>
        <Modal.Body className="text-center">
          <Spinner animation="border" role="status">
            <span className="sr-only">Loading...</span>
          </Spinner>
          <div>Caricamento in corso...</div>
        </Modal.Body>
      </Modal>

      {/* Account (dal nome in alto a destra): nome, email e password in un solo riquadro */}
      <Form>
        <Card>
          <Card.Body className="sid-card-body--spaced">
            <h5 className="sid-form-section">Dati dell'account</h5>
            <Row className="g-4">
              <Col md={6}>
                <Form.Label>Nome</Form.Label>
                <div className="sid-readonly-value">{account.displayName || '—'}</div>
              </Col>
              <Col md={6}>
                <Form.Label>Email di accesso</Form.Label>
                <div className="sid-readonly-value">{account.email || '—'}</div>
              </Col>
            </Row>

            <h5 className="sid-form-section">Cambia email</h5>
            <Row className="g-4">
              <Col md={6}>
                <Form.Label htmlFor="nuova-email">Nuova email</Form.Label>
                <Form.Control id="nuova-email" type="email" name="email" value={formData1.email} onChange={handleChange1} />
                <Form.Text className="text-muted">Ti arriva un link per confermarla: finché non lo apri resta quella di adesso.</Form.Text>
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button className="btn btn-primary" onClick={handleSaveClick1}>Cambia email</Button>
            </div>

            <h5 className="sid-form-section">Cambia password</h5>
            <Row className="g-4">
              <Col md={4}>
                <Form.Label htmlFor="vecchia-password">Password attuale</Form.Label>
                <Form.Control id="vecchia-password" type="password" autoComplete="current-password" name="oldpassword" value={formData2.oldpassword} onChange={handleChange2} />
              </Col>
              <Col md={4}>
                <Form.Label htmlFor="nuova-password">Nuova password</Form.Label>
                <Form.Control id="nuova-password" type="password" autoComplete="new-password" name="newpassword" value={formData2.newpassword} onChange={handleChange2} />
              </Col>
              <Col md={4}>
                <Form.Label htmlFor="conferma-password">Ripeti la nuova password</Form.Label>
                <Form.Control id="conferma-password" type="password" autoComplete="new-password" name="confirmpassword" value={formData2.confirmpassword} onChange={handleChange2} />
              </Col>
            </Row>
            <div className="d-flex justify-content-end mt-4">
              <Button className="btn btn-primary" onClick={handleSaveClick2}>Cambia password</Button>
            </div>
          </Card.Body>
        </Card>
      </Form>
    </>
  )

}
export default Impostazioni;